import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { RotateCcw, TrendingUp } from "lucide-react";
import { SectionHeader, BookCard } from "@/components/site/primitives";
import { fadeUp, stagger } from "@/lib/motion";
import { bookHref } from "@/lib/bookModel";
import { useTrendingBooks } from "@/hooks/useBookSearch";

export default function TrendingBooks() {
  const { books, isLoading, isError, refetch } = useTrendingBooks();

  return (
    <section className="u-container mt-14 md:mt-20" data-testid="explore-trending">
      <SectionHeader eyebrow="What everyone's shelving" title="Trending Now" />
      {isLoading && <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">{[...Array(4)].map((_, i) => <div key={i} className="aspect-[2/3] animate-pulse rounded-md bg-card" />)}</div>}
      {isError && (
        <div className="mt-8 flex flex-col items-center gap-3 text-center">
          <p className="text-sm text-subtle">We couldn’t load trending books right now.</p>
          <button type="button" onClick={() => refetch()} className="inline-flex items-center gap-1.5 rounded-full border border-line px-3 py-1.5 text-xs font-semibold text-ink hover:border-coral/40 hover:text-coral"><RotateCcw className="h-3.5 w-3.5" /> Retry</button>
        </div>
      )}
      {!isLoading && !isError && books.length > 0 && (
        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }} className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
          {books.slice(0, 4).map((book, i) => (
            <motion.div key={book.id || book.title} variants={fadeUp} custom={i} className="flex flex-col gap-2">
              <Link to={bookHref(book)} state={{ hint: book }}>
                <BookCard {...book} />
              </Link>
              {book.stat && <p className="flex items-center gap-1 text-[11px] font-medium text-subtle"><TrendingUp className="h-3 w-3 text-coral" /> {book.stat}</p>}
            </motion.div>
          ))}
        </motion.div>
      )}
      {!isLoading && !isError && books.length === 0 && <p className="mt-8 text-sm text-subtle">No trending books available right now.</p>}
    </section>
  );
}
